/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IFiltered } from 'interfaces/api-response';
import { ISessionCertificateItem } from '../sessions/components/view-session/interface';
import {
  ExpertCertificatesState,
  IExpertCertificateBulkIssuePayload,
  IExpertCertificateIssuePayload,
  IGetExpertCertificatesPayload,
  IReinstateExpertCertificatePayload,
  IRevokeExpertCertificatePayload,
} from './interface';

export const initialState: ExpertCertificatesState = {
  expertId: '',
  certificatesStateLoading: false,
  certificatesRefetchTrigger: false,
  issuingCertificateUserSessionId: '',
  bulkIssuingCertificatesLoading: false,
  revokingCertificateId: '',
  reinstatingCertificateId: '',
  expertCertificates: { result: [], total: 0 },
};

export const expertCertificatesSlice = createSlice({
  name: 'feature/ent-acc/edit-ent-acc/expert/edit-expert/certificates',
  initialState,
  reducers: {
    setExpertId(state: ExpertCertificatesState, action: PayloadAction<string>) {
      state.expertId = action.payload;
    },
    getExpertCertificates(
      state: ExpertCertificatesState,
      _action: PayloadAction<IGetExpertCertificatesPayload>,
    ) {
      state.certificatesStateLoading = true;
    },
    getExpertCertificatesSucceeded(
      state: ExpertCertificatesState,
      action: PayloadAction<IFiltered<ISessionCertificateItem>>,
    ) {
      state.expertCertificates = action.payload;
      state.certificatesStateLoading = false;
    },
    getExpertCertificatesFailed(state: ExpertCertificatesState) {
      state.certificatesStateLoading = false;
    },
    issueExpertCertificate(
      state: ExpertCertificatesState,
      action: PayloadAction<IExpertCertificateIssuePayload>,
    ) {
      state.issuingCertificateUserSessionId = action.payload.userSessionId;
    },
    issueExpertCertificateSucceeded(state: ExpertCertificatesState) {
      state.issuingCertificateUserSessionId = '';
    },
    issueExpertCertificateFailed(state: ExpertCertificatesState) {
      state.issuingCertificateUserSessionId = '';
    },
    bulkIssueExpertCertificates(
      state: ExpertCertificatesState,
      _action: PayloadAction<IExpertCertificateBulkIssuePayload>,
    ) {
      state.bulkIssuingCertificatesLoading = true;
    },
    bulkIssueExpertCertificatesSucceeded(state: ExpertCertificatesState) {
      state.bulkIssuingCertificatesLoading = false;
    },
    bulkIssueExpertCertificatesFailed(state: ExpertCertificatesState) {
      state.bulkIssuingCertificatesLoading = false;
    },
    revokeExpertCertificate(
      state: ExpertCertificatesState,
      action: PayloadAction<IRevokeExpertCertificatePayload>,
    ) {
      state.revokingCertificateId = action.payload.certificateId;
    },
    revokeExpertCertificateSucceeded(state: ExpertCertificatesState) {
      state.revokingCertificateId = '';
    },
    revokeExpertCertificateFailed(state: ExpertCertificatesState) {
      state.revokingCertificateId = '';
    },
    reinstateExpertCertificate(
      state: ExpertCertificatesState,
      action: PayloadAction<IReinstateExpertCertificatePayload>,
    ) {
      state.reinstatingCertificateId = action.payload.certificateId;
    },
    reinstateExpertCertificateSucceeded(state: ExpertCertificatesState) {
      state.reinstatingCertificateId = '';
    },
    reinstateExpertCertificateFailed(state: ExpertCertificatesState) {
      state.reinstatingCertificateId = '';
    },
    triggerRefetchExpertCertificates(state: ExpertCertificatesState) {
      state.certificatesRefetchTrigger = !state.certificatesRefetchTrigger;
    },
  },
});

export const { actions: expertCertificatesActions } = expertCertificatesSlice;
